import { useWindowSize } from "@vueuse/core";
import { watch } from "vue";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

export function useSideMenu() {
  const { width } = useWindowSize();
  const isMobile = computed(() => width.value < 768);
  const isMenuClosed = ref(isMobile.value);
  const activeDropdown = ref(null);

  const route = useRoute();

  const toggleMenuState = () => {
    isMenuClosed.value = !isMenuClosed.value;
  };

  const toggleDropdown = (itemName) => {
    activeDropdown.value = activeDropdown.value === itemName ? null : itemName;
  };

  const closeDropdown = () => {
    activeDropdown.value = null;
  };

  const isActive = (item) => {
    if (!item) return false;

    const matchedPaths = route.matched.map((m) => m.path);

    if (matchedPaths.includes(item.path)) {
      return true;
    }
    if (item.secondary_tabs) {
      return item.secondary_tabs.some((subTab) =>
        matchedPaths.includes(subTab.path)
      );
    }
    if (item.secondary_routes) {
      return item.secondary_routes.some((subTab) =>
        matchedPaths.includes(subTab.path)
      );
    }
    if (item.children) {
      return item.children.some((subTab) => matchedPaths.includes(subTab.path));
    }

    return false;
  };

  watch(isMobile, (isClosed) => {
    isMenuClosed.value = isClosed;
  });

  return {
    isMenuClosed,
    activeDropdown,
    toggleMenuState,
    toggleDropdown,
    closeDropdown,
    isActive,
    isMobile,
  };
}
